import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation"; // optional if AOS.init is in RootLayout
import RootLayout from "./layout";
import arts from "../assets/images/admission.jpg";

const AverageSchoolDay = () => {
  return (
    <>
      <RootLayout>
        {/* If AOS is initialized in RootLayout, you can remove <Animation /> */}
        <Animation />
        <HeaderOne />
        <Breadcrumb title={"Average School Day"} />

        <section className="join-community">
          <div className="container container--lg">
            <div className="rounded-20 py-60 px-8">
              <div className="container">
                {/* Arts */}
                <div className="row gy-4 align-items-center">
                  <div className="col-lg-7">
                    <div className="join-community__content">
                      <div className="mb-40">
                        <h3 className="mb-24" data-aos="fade-up">
                          School Day Schedule
                        </h3>
                        <p
                          className="text-neutral-500 text-line-2"
                          data-aos="fade-up"
                          data-aos-delay="120"
                        >
                          The early years follows flexible schedules starting
                          the day with assemblies, physical exercise, circle
                          time or group-chat. The students of early years have a
                          mid-morning break followed with out-door play. The
                          school day is scheduled to ensure the child’s holistic
                          learning needs are met at all times.
                          <br />
                          <br />
                          The school timings for students in the early learning
                          program:
                          <br />
                          Montessori and Kindergarten – 8:00 am to 12:30 pm
                          <br />
                          <br />
                          For students of Classes 1 and above, the school begins
                          at 8:00 am and ends at 2:50 pm with a mid-morning
                          snack break and afternoon lunch break. The breaks also
                          give students time to interact and play with their
                          peers. A typical day begins with a whole school
                          assembly which sets the tone for the day. The students
                          of class 4 and above take turns to make presentations,
                          conduct quizzes and other interactive programmes on
                          current affairs. This gives them the opportunity to
                          hone their public speaking skills, increase their
                          general knowledge through active involvement and
                          creates a healthy student culture of self-learning.
                          <br />
                          <br />
                          The rest of the day students participate in
                          interactive classes where spontaneity is actively
                          encouraged. Additionally, co-curricular activities
                          like sports, music, dance, etc. are interwoven into
                          the daily schedule to ensure the holistic development
                          of the students.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-lg-5"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <div className="join-community__thumb text-end position-relative">
                      <img
                        src={arts}
                        alt="Student Learning"
                        className="img-fluid rounded-12"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* /container */}
            </div>
          </div>
        </section>

        <FooterThree />
      </RootLayout>
    </>
  );
};

export default AverageSchoolDay;
